import React, { useState, useEffect, useCallback } from "react";
import Header from "../../commons/Header/Header";
import Sidebar from "../../commons/Sidebar/Sidebar";
// eslint-disable-next-line no-unused-vars
import DeleteIcon from "../../assets/images/icons/delete-w.svg";
import { Link } from "react-router-dom";
import { UI_CONSTANTS } from "../../utils/constants";
import editImage from "../../assets/images/icons/edit-2.svg";
import Modal from "../../commons/Modal/Modal";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import { toast } from "react-toastify";

function PartnerUpdateTypeManagement() {
  const [loading, setLoading] = useState(false);
  const [partnerUpdateTypes, setPartnerUpdateTypes] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(10); // Default limit per page
  const [totalPages, setTotalPages] = useState(1);
  const [logoutModal, setLogoutModal] = useState({ value: false });
  const [itemToDelete, setItemToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [statusUpdatingId, setStatusUpdatingId] = useState(null);

  const normalizePartnerUpdateTypeData = (data) => {
    if (!data) return [];
    if (Array.isArray(data?.partnerUpdateTypes)) return data.partnerUpdateTypes;
    if (Array.isArray(data?.partnerUpdateType)) return data.partnerUpdateType;
    if (Array.isArray(data?.partner_update_types)) return data.partner_update_types;
    if (Array.isArray(data?.data)) return data.data;
    if (Array.isArray(data)) return data;
    return [];
  };

  const getPartnerUpdateTypes = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      params.append("page", currentPage.toString());
      params.append("limit", limit.toString());
      if (searchTerm) {
        params.append("search", searchTerm);
      }

      const response = await handleApiCall("get", `${endpoints.partnerUpdateTypeList}?${params.toString()}`);
      if (response?.data?.code === 200 || response?.data?.code === "200" || response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS) {
        const responseData = response?.data?.data;
        setPartnerUpdateTypes(normalizePartnerUpdateTypeData(responseData));
        setTotalPages(responseData?.totalPages || responseData?.pagination?.totalPages || 1);
      } else if (response?.error) {
        console.error("Error fetching partner update types:", response?.message);
        setPartnerUpdateTypes([]);
      } else {
        setPartnerUpdateTypes([]);
      }
    } catch (error) {
      console.error("Error fetching partner update types:", error);
      setPartnerUpdateTypes([]);
    } finally {
      setLoading(false);
    }
  }, [currentPage, limit, searchTerm]);

  useEffect(() => {
    getPartnerUpdateTypes();
  }, [getPartnerUpdateTypes]);

  // eslint-disable-next-line no-unused-vars
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleStatusToggle = async (itemId, currentStatus) => {
    try {
      const newStatus = currentStatus === 1 ? 0 : 1;
      setStatusUpdatingId(itemId);

      const response = await handleApiCall("put", `${endpoints.updatePartnerUpdateTypeStatus}`, {
        status: newStatus,
        partner_update_type_id : itemId
      });

      if (response?.data?.code === 200 || response?.data?.code === "200" || response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS) {
        toast.success("Partner update type status updated successfully!");
        getPartnerUpdateTypes();
      } else if (response?.error) {
        console.error("Error updating partner update type status:", response?.message);
      }
    } catch (error) {
      console.error("Error updating partner update type status:", error);
    } finally {
      setStatusUpdatingId(null);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const handleDeleteClick = (itemId) => {
    setItemToDelete(itemId);
    setLogoutModal({ value: true });
  };

  const handleDeleteConfirm = async () => {
    if (!itemToDelete) return;
    // Delete API not provided yet
    setDeleting(true);
    toast.info("Delete partner update type API is not available yet.");
    setTimeout(() => {
      setLogoutModal({ value: false });
      setItemToDelete(null);
      setDeleting(false);
    }, 800);
  };

  const handleDeleteCancel = () => {
    setLogoutModal({ value: false });
    setItemToDelete(null);
  };

  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-4 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">Partner Update Type Management</h3>
              <Link to="/add-partner-update-type" className="btn btn-primary rounded-2 px-3 ml-auto">
                {UI_CONSTANTS.BUTTON_LABELS.CREATE_NEW} <span className="ml-2">+</span>
              </Link>
            </div>

            {/* Search Bar */}
            {/* <div className="row mb-3">
              <div className="col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control search-icon left-icon border"
                    placeholder={UI_CONSTANTS.PLACEHOLDERS.SEARCH}
                    value={searchTerm}
                    onChange={handleSearch}
                  />
                </div>
              </div>
            </div> */}

            <div className="table-responsive px-0">
              <table className="table table-striped trim">
                <thead>
                  <tr>
                    <th width="80">{UI_CONSTANTS.TABLE_HEADERS.SR_NO}</th>
                    <th width="150">Name (English)</th>
                    <th>Name (Arabic)</th>
                    <th>{UI_CONSTANTS.TABLE_HEADERS.STATUS}</th>
                    <th className="text-center">{UI_CONSTANTS.TABLE_HEADERS.ACTIONS}</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="5" className="text-center py-4">
                        <div className="spinner-border" role="status">
                          <span className="sr-only">{UI_CONSTANTS.BUTTON_LABELS.LOADING}</span>
                        </div>
                      </td>
                    </tr>
                  ) : !Array.isArray(partnerUpdateTypes) || partnerUpdateTypes.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center py-4">
                        {UI_CONSTANTS.EMPTY_STATES.NO_DATA_FOUND}
                      </td>
                    </tr>
                  ) : (
                    partnerUpdateTypes.map((item, index) => {
                      const itemId = item._id || item.id || `partner-update-type-${index}`;
                      const nameEn = item.title_en || item.title_english || item.name_en || item.name_english || item.name || "";
                      const nameAr = item.title_ar || item.title_arabic || item.name_ar || item.name_arabic || "";
                      const status = item.status ?? 0;

                      return (
                        <tr key={itemId}>
                          <td>{(currentPage - 1) * limit + index + 1}</td>
                          <td className="text-center">{nameEn || UI_CONSTANTS.EMPTY_STATES.NO_DATA_FOUND}</td>
                          <td className="text-center" dir="rtl">{nameAr || UI_CONSTANTS.EMPTY_STATES.NO_DATA_FOUND}</td>
                          <td>
                            <label className="custom-control custom-switch p-1 ml-4 mb-0 mt-1" role="button">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                checked={status === 1}
                                onChange={() => handleStatusToggle(itemId, status)}
                                disabled={statusUpdatingId === itemId}
                              />
                              <span className="custom-control-label custom-toggle" />
                            </label>
                          </td>
                          <td>
                            <div className="d-flex align-items-center justify-content-center">
                              <Link to={`/edit-partner-update-type/${itemId}`} state={{ partnerUpdateType: item }} className="btn btn-link p-0 mx-2">
                                <img src={editImage} alt={UI_CONSTANTS.BUTTON_LABELS.EDIT} className="mr-2" />
                              </Link>
                              {/* <button className="btn btn-link p-0 mx-2" onClick={() => handleDeleteClick(itemId)}>
                                <img src={DeleteIcon} alt={UI_CONSTANTS.BUTTON_LABELS.DELETE} />
                              </button> */}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="d-flex justify-content-center mt-4">
                <nav aria-label="Page navigation">
                  <ul className="pagination">
                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                      <button className="page-link" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                        {UI_CONSTANTS.BUTTON_LABELS.PREVIOUS || "Previous"}
                      </button>
                    </li>
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                      <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
                        <button className="page-link" onClick={() => handlePageChange(page)}>
                          {page}
                        </button>
                      </li>
                    ))}
                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                      <button className="page-link" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                        {UI_CONSTANTS.BUTTON_LABELS.NEXT || "Next"}
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </div>
        </div>
      </div>
      <Modal show={logoutModal.value} onClose={handleDeleteCancel} style={{ zIndex: "1000" }} className=" shadow-none">
        <div className="modal-dialog modal-md modal-center" role="document">
          <div className="modal-content bg-black border-light">
            <div className="modal-body text-center my-4 py-4">
              <h4 className="text-white">
                Do you want to
                <br />
                Delete this partner update type?
              </h4>
              <div className="col-sm-12 mx-auto d-flex align-items-center mt-4 row">
                <div className="col-6 px-2">
                  <button type="button" className="btn btn-primary btn-lg btn-block font-16 rounded-pill" onClick={handleDeleteConfirm} disabled={deleting}>
                    {deleting ? "Deleting..." : "Yes"}
                  </button>
                </div>
                <div className="col-6 px-2">
                  <button type="button" className="btn btn-default btn-lg btn-block font-16 rounded-pill" onClick={handleDeleteCancel} disabled={deleting}>
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default PartnerUpdateTypeManagement;

